export enum IntercomFunctionKey {
  getPersonById = "getPersonById",
  getStories = "getStories",
  getStoryBySlug = "getStoryBySlug",
  getStoryById = "getStoryById",
  getImages = "getImages",
  getAudios = "getAudios",
  getVideos = "getVideos",
  getImagesBulk = "getImagesBulk",
  getSecurities = "getSecurities",
  getNewsletters = "getNewsletters",
  getNiCodeStories = "getNiCodeStories",
  getUserAuthors = "getUserAuthors",
  getUserNewsletters = "getUserNewsletters",
  getUserTopics = "getUserTopics",
  getUserSecurities = "getUserSecurities",
  getTopMovingSecurities = "getTopMovingSecurities",
  getPopularResources = "getPopularResources",
  getPopularEntities = "getPopularEntities",
  getRecommended = "getRecommended",
  getRelated = "getRelated",
  getRecommendedPopular = "getRecommendedPopular",
  getUserBookmarks = "getUserBookmarks",
  getUserProfile = "getUserProfile",
  getBio = "getBio",
  getCompaniesPublic = "getCompaniesPublic",
  getCompaniesPrivate = "getCompaniesPrivate",
  getSrchDataSecurities = "getSrchDataSecurities",
}

export const INTERCOM_API_ENDPOINTS = {
  [IntercomFunctionKey.getPersonById]: "api/daper/people/id",
  [IntercomFunctionKey.getStories]: "/api/daper/stories",
  [IntercomFunctionKey.getStoryBySlug]: "/api/daper/stories/slug",
  [IntercomFunctionKey.getStoryById]: "/api/daper/stories/id",
  [IntercomFunctionKey.getImages]: "/api/images",
  [IntercomFunctionKey.getVideos]: "/api/videos",
  [IntercomFunctionKey.getAudios]: "/api/audios",
  [IntercomFunctionKey.getImagesBulk]: "/api/images/bulk",
  [IntercomFunctionKey.getSecurities]: "/api/securities",
  [IntercomFunctionKey.getNewsletters]: "/api/newsletters",
  [IntercomFunctionKey.getNiCodeStories]: "/api/stories/ni",
  [IntercomFunctionKey.getTopMovingSecurities]: "/api/securities/top-moving",
  [IntercomFunctionKey.getUserAuthors]: "/api/user/authors",
  [IntercomFunctionKey.getUserSecurities]: "/api/user/securities",
  [IntercomFunctionKey.getUserTopics]: "/api/user/topics",
  [IntercomFunctionKey.getBio]: "/api/people/bio",
  [IntercomFunctionKey.getCompaniesPublic]: "/api/companies/public",
  [IntercomFunctionKey.getCompaniesPrivate]: "/api/companies/private",
  [IntercomFunctionKey.getSrchDataSecurities]: "/api/srchdata/securities",
};
